// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"e4c7b6a4","685":"3684abe5","787":"014780ba","864":"9b658bd4"}[chunkId] + ".chunk.js";
};